var isFunction = function (f) {
  return typeof f === "function";
};

export default isFunction;